import {useHistory, useIsDirectEntryCallback} from '@aboutyou/router';
import React, {useEffect, useRef} from 'react';
import {useAuthenticationPrompt} from '../../../features/Authentication/AuthenticationProvider/useAuthenticationPrompt';
import {useIsAuthenticated} from '../../../features/Authentication/hooks/useIsAuthenticated';

export const CouponLandingPageConditionalLoginWrapper: React.FC<{
  View: React.FC;
}> = ({View}) => {
  const getIsDirectEntry = useIsDirectEntryCallback();
  const history = useHistory();
  const isDirectEntry = getIsDirectEntry();
  const {showUserAuthenticationPrompt} = useAuthenticationPrompt();
  const Authenticated = useIsAuthenticated();
  const triggeredOnce = useRef(false);

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    if (
      isDirectEntry &&
      !Authenticated.isAuthenticated &&
      !Authenticated.isUserDataLoading &&
      !triggeredOnce.current
    ) {
      triggeredOnce.current = true;
      showUserAuthenticationPrompt({
        context: 'coupon-landing-page-conditional-login',
        needsCheckoutSession: false,
        onCancel: () => {
          // on direct landing on CLP we want to go back to browse page if user declines authentication.
          // Only logged in users will be getting coupon emails so we know that they can do it.

          // eslint-disable-next-line local-rules/set-state-in-use-effect
          setTimeout(() => {
            history.push('/');
          }, 100);
        },
      });
    }
  }, [Authenticated, history, isDirectEntry, showUserAuthenticationPrompt]);

  return <View />;
};
